import script from "./home.vue?vue&type=script&setup=true&lang=js"
export * from "./home.vue?vue&type=script&setup=true&lang=js"

import "./home.vue?vue&type=style&index=0&id=7b696e4c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7b696e4c"]])

export default __exports__